import { render, staticRenderFns } from "./RyzerScore.vue?vue&type=template&id=5a9d7395&scoped=true&"
import script from "./RyzerScore.vue?vue&type=script&lang=ts&"
export * from "./RyzerScore.vue?vue&type=script&lang=ts&"
import style0 from "./RyzerScore.vue?vue&type=style&index=0&id=5a9d7395&prod&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "5a9d7395",
  null
  
)

export default component.exports